export const navItemMap = {
  creator: { to: '/creator', label: 'Insights' },
  feedback: { to: '/feedback', label: 'Feedback' },
  'short-url': { to: '/short-url', label: 'Short Url' },
  'reset-password': { to: '/reset-password', label: 'Reset Password' },
  refunds: { to: '/refunds', label: 'Refunds' },
  alumni: { to: '/alumni', label: 'Alumni' },
  courses: { to: '/courses', label: 'Courses' },
  'course-offers': { to: '/course-offers', label: 'Course Offers' },
  comments: { to: '/comments', label: 'Comments' },
  'pricing-options': { to: '/pricing-options', label: 'Pricing Options' },
  'course-offer-announcements': {
    to: '/course-offer-announcements',
    label: 'Course Offer Announcements'
  },
  units: { to: '/units', label: 'Units' },
  'unit-offers': { to: '/unit-offers', label: 'Unit Offers' },
  subunits: { to: '/subunits', label: 'Subunits' },
  trainers: { to: '/trainers', label: 'Trainers' },
  creators: { to: '/creators', label: 'Creators' },
  learners: { to: '/learners', label: 'Learners' },
  'learners-social-media': {
    to: '/learners-social-media',
    label: 'Learners Social Media'
  },
  enrolments: { to: '/enrolments', label: 'Enrolment tracking' },
  'trial-class': { to: '/trial-class', label: 'Trial Classes' },
  'email-templates': { to: '/email-templates', label: 'Email Templates' },
  promo: { to: '/promo', label: 'Promo Codes' },
  user: { to: '/user', label: 'Settings' },
  'trainer-user': { to: '/trainer-user', label: 'Settings' },
  'community/events': {
    to: '/community/events',
    label: 'Community Events'
  },
  '/community-applications': {
    to: '/community-applications',
    label: 'Communities Application'
  },
  '/course-applications': {
    to: '/course-applications',
    label: 'Course Application'
  },
  '/community-mail-logs': {
    to: '/community-mail-logs',
    label: 'Community Email Logs (Sendgrid)'
  },
  '/start-community-applications': {
    to: '/start-community-applications',
    label: 'Start Community Applications'
  }
};

export const defaultNavItems = [
  {
    to: '/community-applications',
    label: 'Community Applications'
  },
  { to: '/community/events', label: 'Community Events' },
  { to: '/community/resources', label: 'Community Resources' },
  { to: '/community-mail-logs', label: 'Community Email Logs (Sendgrid)' },
  {
    to: '/start-community-applications',
    label: 'Start Community Applications'
  },
  { to: '/creator', label: 'Insights' },
  { to: '/feedback', label: 'Feedback' },
  { to: '/short-url', label: 'Short Url' },
  { to: '/reset-password', label: 'Reset Password' },
  { to: '/refunds', label: 'Refunds' },
  { to: '/alumni', label: 'Alumni' },
  { to: '/course-applications', label: 'Course Applications' },
  { to: '/courses', label: 'Courses' },
  { to: '/course-offers', label: 'Course Offers' },
  { to: '/comments', label: 'Comments' },
  { to: '/pricing-options', label: 'Pricing Options' },
  {
    to: '/course-offer-announcements',
    label: 'Course Offer Announcements'
  },
  { to: '/units', label: 'Units' },
  { to: '/unit-offers', label: 'Unit Offers' },
  { to: '/subunits', label: 'Subunits' },
  { to: '/trainers', label: 'Trainers' },
  { to: '/creators', label: 'Creators' },
  { to: '/learners', label: 'Learners' },
  { to: '/learners-social-media', label: 'Learners Social Media' },
  { to: '/enrolments', label: 'Enrolment tracking' },
  { to: '/trial-class', label: 'Trial Classes' },
  { to: '/email-templates', label: 'Email Templates' },
  { to: '/promo', label: 'Promo Codes' },
  { to: '/creator-revenue', label: 'Creator Revenue' },
  { to: '/merge-accounts', label: 'Merge Learner Accounts' },
  { to: '/user', label: 'Settings' }
];
